<template>
  <div id="app">
    <CookieBanner @accept="checkCookies" v-if="cookieSettings.length < 1" />
    <router-view />
  </div>
</template>

<script>
import CookieBanner from '@/components/CookieBanner';

export default {
  name: 'app',
  components: { CookieBanner },
  data: function() {
    return {
      cookieSettings: [],
    };
  },
  mounted() {
    this.checkCookies();
    if (this.cookieSettings.includes('statistics')) {
      this.enableStatistics();
    }
  },
  watch: {
    $route(to) {
      document.title = to.meta.title || 'Maddy App';
    },
  },
  methods: {
    async enableStatistics() {
      this.$gtag.optIn();
    },
    checkCookies() {
      let cookies = document.cookie
        .split('; ')
        .find(row => row.startsWith('cookie_settings'));

      if (!cookies) return;
      cookies = cookies.split('=')[1];

      cookies.split(',').forEach(cookie => {
        this.cookieSettings.push(cookie);
      });
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/global/global.scss';

#app {
  min-height: 100vh;
  display: flex;
}

figure {
  margin: 0;
  padding: 0;
}
</style>
